import { useState } from 'react'
import cutileiApi from 'services/cutileiApi'
import { getApiErrorMessage } from 'services/apiError'
import MainButton from 'components/Buttons/MainButton'
import verificationCodeValidator from 'validators/verificationCodeValidator'
import { Formik } from 'formik'

import {
  Form,
  FormField,
  InfoText,
  MaskedInput,
  WarningText,
  ErrorContainer
} from '../styles'

export default function ValidateCodeForm ({
  userType = 'business',
  email,
  onSubmit: handleSubmitForm
}) {
  const [errorMessage, setErrorMessage] = useState (null)

  return (
    <Formik
      validationSchema={verificationCodeValidator}
      initialValues={{
        'verification_code': ''
      }}
      onSubmit={async (values, { setSubmitting }) => {
        const { verification_code } = values

        try {
          setSubmitting (true)

          const apiEndpoint = userType === 'company'
            ? '/verify_account/companies'
            : '/verify_account/businesses'

          // POST em vez de GET com o codigo na query string: query string cai em log
          // de acesso, CDN e APM. O e-mail vai junto para o servidor conferir que o
          // codigo e mesmo de quem o pediu.
          const { data: userData } = await cutileiApi.post (
            `${apiEndpoint}/verify`, { email, code: verification_code }
          )

          setSubmitting (false)
          handleSubmitForm (userData)
        } catch (error) {
          setSubmitting (false)
          setErrorMessage (getApiErrorMessage (error))
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        isSubmitting,
        handleChange,
        handleBlur,
        handleSubmit
      }) => (
        <Form>
          <InfoText>
            Insira o código de 6 dígitos enviado para seu e-mail para prosseguir
          </InfoText>
          <FormField>
            <MaskedInput
              name='verification_code'
              placeholder='Código de 6 dígitos'
              options={{blocks: [6], numericOnly: true}}
              value={values.verification_code}
              onChange={handleChange ('verification_code')}
              onBlur={handleBlur ('verification_code')}
            />
            {touched.verification_code && errors.verification_code && (
              <WarningText>
                {errors.verification_code}
              </WarningText>
            )}
          </FormField>
          {errorMessage && (
            <ErrorContainer>
              <p>{errorMessage}</p>
            </ErrorContainer>
          )}
          <MainButton
            label='Validar código'
            onClick={handleSubmit}
            disabled={isSubmitting}
            loading={isSubmitting}
            width={140}
          />
        </Form>
      )}
    </Formik>
  )
}
